module.exports = __webpack_public_path__ + "static/media/album.b51e0b14.svg";